module.exports = __webpack_public_path__ + "img/level3addon_mining_tool_shadow-2.095b3946.png";